import { render, staticRenderFns } from "./SpaceSettingsPage.vue?vue&type=template&id=05e0f75e&scoped=true"
import script from "./SpaceSettingsPage.vue?vue&type=script&lang=ts"
export * from "./SpaceSettingsPage.vue?vue&type=script&lang=ts"
import style0 from "./SpaceSettingsPage.vue?vue&type=style&index=0&id=05e0f75e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e0f75e",
  null
  
)

export default component.exports